import { DigitalData, DigitalDataEvent } from './types/types';
import USER_EVENTS from './types/enums';

export function cloneDigitalData(digitalData: DigitalData): DigitalData {
  return JSON.parse(JSON.stringify(digitalData));
}

export function pageViewMutation(
  event: DigitalDataEvent,
  digitalData: DigitalData
): DigitalData {
  if (event.name !== USER_EVENTS.PAGE_VIEW) {
    return digitalData;
  }

  const newDigitalData: DigitalData = cloneDigitalData(digitalData);

  const { pageId, pathname, attributes } = event.data;

  newDigitalData.page.pageInfo = { pageId, pathname, attributes };

  return newDigitalData;
}
